import { getAllAdmins$ } from "../actions/admin";

export const initialState = {
  error: "",
  adminData: [],
  loading: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case getAllAdmins$.TRIGGER:
      return { ...initialState };

    case getAllAdmins$.REQUEST:
      return { ...state, loading: true };

    case getAllAdmins$.SUCCESS:
      return { ...state, data: action.payload };

    case getAllAdmins$.FAILURE:
      return { ...state, error: action.payload };

    case getAllAdmins$.FULFILL:
      return { ...state, loading: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/admin.js